/**
 * Types communs partagés à travers l'API
 */




/**
 * Helper pour les appels API authentifiés
 * Utilise le client API principal avec gestion d'erreurs sécurisée
 */
interface AuthenticatedFetch {
  get: <T>(url: string) => Promise<T>;
  post: <T>(url: string, data?: unknown) => Promise<T>;
  put: <T>(url: string, data?: unknown) => Promise<T>;
  delete: (url: string) => Promise<void>;
}

export const createAuthenticatedFetch = (): AuthenticatedFetch => {
  return {
    async get<T>(url: string): Promise<T> {
      const { apiClient } = await import('@/services/api');
      const response = await apiClient.get<T>(url);
      return response.data;
    },

    async post<T>(url: string, data?: unknown): Promise<T> {
      const { apiClient } = await import('@/services/api');
      const response = await apiClient.post<T>(url, data);
      return response.data;
    },

    async put<T>(url: string, data?: unknown): Promise<T> {
      const { apiClient } = await import('@/services/api');
      const response = await apiClient.put<T>(url, data);
      return response.data;
    },

    async delete(url: string): Promise<void> {
      const { apiClient } = await import('@/services/api');
      await apiClient.delete(url);
    }
  };
}; 

/**
 * Interface de base pour toutes les entités
 */
export interface Entity {
  uuid: string;
  user_id: string;
  is_public: boolean;
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
}

/**
 * Interface de base pour les réponses API
 */
export interface BaseResponse {
  success: boolean;
  message?: string;
  error?: string;
  created_at: string;
  updated_at: string;
}

/**
 * Interface de base pour les requêtes de création
 */
export interface BaseCreate {
  user_id: string;
  is_public: boolean;
  uuid?: string; // UUID optionnel pour permettre la création avec un UUID spécifique
}

/**
 * Interface de base pour les requêtes de mise à jour
 */
export interface BaseUpdate {
  is_public?: boolean;
  is_deleted?: boolean;
}

/**
 * Type utilitaire pour les relations avec les memos
 */
export interface WithMemos<T> {
  memos: T[];
}

/**
 * Interface pour la réponse de vérification d'existence d'un asset
 */
export interface AssetExistsResponse {
  exists: boolean;
  is_owner: boolean;
  is_admin?: boolean;
  is_public: boolean;
  is_confidential?: boolean; // Pour les locations confidentielles
  user_id?: string;
}
